import React from 'react';
import { Link } from 'react-router-dom';
import StructuredData from './StructuredData';

/**
 * SEO breadcrumbs with JSON-LD BreadcrumbList schema.
 *
 * Props:
 *   items: [{ label: 'Home', href: '/' }, { label: 'Bike Services', href: '/bike-services' }, { label: 'Current Page' }]
 *
 * Last item has no href (current page).
 */
const Breadcrumbs = ({ items, withSchema = true }) => {
  if (!items || items.length === 0) return null;

  const schemaItems = items.map((item, i) => ({
    '@type': 'ListItem',
    position: i + 1,
    name: item.label,
    ...(item.href ? { item: `https://www.ridenrepair.com${item.href}` } : {}),
  }));

  return (
    <>
      {withSchema && (
        <StructuredData
          data={{
            '@type': 'BreadcrumbList',
            itemListElement: schemaItems,
          }}
        />
      )}
      {/* Visual breadcrumbs hidden — JSON-LD schema kept for SEO */}
      <nav className="rr-breadcrumbs rr-sr-only" aria-label="Breadcrumb">
        <ol className="rr-breadcrumbs__list">
          {items.map((item, i) => (
            <li key={i} className="rr-breadcrumbs__item">
              {i > 0 && <span className="rr-breadcrumbs__separator">›</span>}
              {item.href ? (
                <Link to={item.href}>{item.label}</Link>
              ) : (
                <span aria-current="page">{item.label}</span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
};

export default Breadcrumbs;
